import React from "react";
import {
    Box, Grid, Typography, useTheme, Chip,
    Stack,
    Tooltip
} from "@mui/material";
import DateChips from "../../../components/works/DateChips";
import { formatDate } from "../../../utils/TimeFormat";
import { MovieFilter, GroupAddOutlined, Engineering, AccessTime, LocationOn } from "@mui/icons-material";

const AdminWorkAsPost = ({ workContent }) => {
    const theme = useTheme();

    console.log("workContent", workContent);

    return (
        <Box
            sx={{
                border: '1px solid',
                borderColor: 'divider',
                mb: 1,
                p: 1,
                borderRadius: 2,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
            }}
        >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                <Typography
                    variant="h6"
                    lineHeight={1.3}
                    gutterBottom
                >
                    {workContent.title.charAt(0).toUpperCase() + workContent.title.slice(1)}
                    {/* {workContent.is_urgent === 1 && (
                    <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', ml: 1 }}>
                        <Typography variant="caption" fontWeight="bold" color="error">
                            Urgent *
                        </Typography>
                    </Box>
                )} */}
                    {/* <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', ml: 1 }}>
                    <Typography variant="body1" >
                        <Tooltip title="Work Status By Admin" placement="top">
                            <Chip
                                size="small"
                                label={workContent.admin_work_status}
                                onClick={() => { }}
                                clickable={false}
                                color="primary"
                                sx={{
                                    ml: 0.5,
                                    height: '1.2rem',

                                }}
                            />
                        </Tooltip>

                    </Typography>
                </Box> */}
                </Typography>
                <Tooltip title="Job Status By Admin" placement="top">
                    <Chip
                        size="small"
                        label={workContent.admin_work_status}
                        onClick={() => { }}
                        clickable={false}
                        color="primary"
                        sx={{
                            fontSize: '0.75rem',
                            height: '1.2rem',
                        }}
                    />
                </Tooltip>
            </Box>

            <Grid container spacing={1}>
                <Grid size={{ xs: 12 }}>
                    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
                        <MovieFilter sx={{ color: theme.palette.text.secondary, fontSize: '1.2rem' }} />
                        <Typography variant="body2">
                            <strong>Type:</strong> {workContent.work_project_type?.work_project_type_name}
                        </Typography>
                    </Box>
                </Grid>

                <Grid size={{ xs: 12 }}>
                    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
                        <Engineering sx={{ color: theme.palette.text.secondary, fontSize: '1.2rem' }} />
                        <Typography variant="body2">
                            <strong>Role:</strong> {workContent.work_roles.map((role) => role.role_name).join(', ')}
                        </Typography>
                    </Box>
                </Grid>

                <Grid size={{ xs: 12 }}>
                    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
                        <AccessTime sx={{ color: theme.palette.text.secondary, fontSize: '1.2rem' }} />
                        <Typography variant="body2">
                            <strong>Duration:</strong> {workContent.duration} {workContent.duration > 1 ? 'days' : 'day'}
                        </Typography>
                    </Box>
                </Grid>

                {/* {workContent.shoot_date.length > 0 && (
                    <Grid size={{ xs: 12 }}>
                        <DateChips data={workContent.shoot_date} postview={true} />
                    </Grid>
                )} */}

                <Grid size={{ xs: 12 }}>
                    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
                        <LocationOn sx={{ color: theme.palette.text.secondary, fontSize: '1.2rem' }} />
                        <Typography variant="body2">
                            <strong>Location:</strong> {workContent.locations.map((loc) => `${loc.city}, ${loc.country}`).join(' | ')}
                        </Typography>
                    </Box>
                </Grid>

                <Grid size={{ xs: 12 }}>
                    <Stack direction="row" spacing={1} justifyContent="space-between" alignItems="center">
                        <Chip
                            onClick={() => { }}
                            clickable={false}
                            size="small"
                            icon={<GroupAddOutlined sx={{ color: theme.palette.text.secondary }} />}
                            label={`${workContent.applied_users_count || 0} applicants`}
                            sx={{
                                color: theme.palette.text.secondary,
                                backgroundColor: 'transparent',
                                border: '1px solid',
                                borderColor: 'divider',
                                '& .MuiChip-icon': { color: theme.palette.text.secondary },
                                fontWeight: 'medium',
                            }}
                        />

                        {/* <Typography variant="caption" color="primary">
                            Last Date: {formatDate(workContent.last_date)}
                            <Typography
                                variant="caption"
                                component="span"
                                sx={{
                                    color: workContent.status === 1 ? 'green' : workContent.status === 0 ? 'red' : 'orange',
                                    fontWeight: 'bold',
                                    ml: 0.5,
                                }}
                            >
                                ({workContent.status === 1 ? 'Open' : workContent.status === 0 ? 'Closed' : 'Draft'})
                            </Typography>
                        </Typography> */}
                    </Stack>
                </Grid>

                {workContent.description && (
                    <Grid size={{ xs: 12 }}>
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                            <strong>Description:</strong>
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{
                                mt: 0.5,
                                display: '-webkit-box',
                                WebkitLineClamp: 3,
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }}
                        >
                            {workContent.description}
                        </Typography>
                    </Grid>
                )}
            </Grid>
        </Box>
    );
};

export default AdminWorkAsPost;